import { useState } from "react";
import { cn } from "../lib/cn";

export type Locale = "ko" | "ja";

export function LocaleToggle({
  value,
  onChange,
  className,
}: {
  value?: Locale;
  onChange?: (l: Locale) => void;
  className?: string;
}) {
  const [internal, setInternal] = useState<Locale>(value ?? "ko");
  const current = value ?? internal;
  const set = (l: Locale) => {
    setInternal(l);
    onChange?.(l);
  };

  const options: { v: Locale; label: string }[] = [
    { v: "ko", label: "한국어" },
    { v: "ja", label: "日本語" },
  ];

  return (
    <div
      role="radiogroup"
      aria-label="언어 전환"
      className={cn(
        "inline-flex rounded-full kj-glass p-1 text-sm",
        className,
      )}
    >
      {options.map((o) => (
        <button
          key={o.v}
          role="radio"
          aria-checked={current === o.v}
          type="button"
          onClick={() => set(o.v)}
          className={cn(
            "rounded-full px-3 py-1 transition-colors",
            current === o.v
              ? "bg-primary-500 text-white shadow-glass-sm"
              : "text-fg-muted hover:text-fg",
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
